module.exports = __webpack_public_path__ + "img/service_image9.33c4e5dd.jpg";